import React, { useState } from 'react';
import { Menu, X, Coffee, Gamepad2, MapPin, ShoppingBag, Calendar, User, Shield } from 'lucide-react';
import { PageView } from '../types';

interface NavigationProps {
  activePage: PageView;
  onNavigate: (page: PageView) => void;
}

export const Navigation: React.FC<NavigationProps> = ({ activePage, onNavigate }) => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems: { id: PageView; label: string; icon: React.ReactNode }[] = [
    { id: 'HOME', label: 'Úvod', icon: <Shield size={16} /> },
    { id: 'CAFE', label: 'Kavárna', icon: <Coffee size={16} /> },
    { id: 'GAMING', label: 'Herní Doupě', icon: <Gamepad2 size={16} /> },
    { id: 'MEMBERSHIP', label: 'Členství', icon: <User size={16} /> },
    { id: 'RESERVATION', label: 'Rezervace', icon: <Calendar size={16} /> },
    { id: 'SHOP', label: 'Obchod', icon: <ShoppingBag size={16} /> },
  ];

  return (
    <nav className="sticky top-0 z-50 bg-guild-bg/95 border-b border-guild-gold/20 backdrop-blur-md shadow-sm transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20 items-center">
          
          {/* Logo Area - Minimalist */}
          <div className="flex items-center cursor-pointer group gap-3" onClick={() => onNavigate('HOME')}>
             <div className="w-10 h-10 bg-guild-gold rounded-sm flex items-center justify-center text-white shadow-md group-hover:bg-guild-dark transition-colors duration-500">
                <span className="font-display font-bold text-xl">K</span>
             </div>
             <div className="flex flex-col">
                <span className="font-display font-bold text-xl tracking-wider text-guild-dark group-hover:text-guild-gold transition-colors">
                    KAVÁRNA
                </span>
                <span className="text-[10px] uppercase tracking-[0.3em] text-guild-muted">NA NÁMĚSTÍ</span>
             </div>
          </div>

          {/* Desktop Menu - Clean Typography */}
          <div className="hidden md:flex space-x-2">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => onNavigate(item.id)}
                className={`px-4 py-2 rounded-sm font-sans font-medium text-xs tracking-widest uppercase transition-all duration-300 flex items-center gap-2 border border-transparent
                  ${activePage === item.id 
                    ? 'text-guild-gold border-b border-guild-gold bg-white shadow-sm' 
                    : 'text-guild-dark hover:text-guild-gold hover:bg-white/50'
                  }`}
              >
                {item.label}
              </button>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-guild-dark hover:text-guild-gold p-2 transition-colors"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-b border-guild-gold/20 animate-fade-in absolute w-full shadow-lg">
          <div className="px-4 pt-2 pb-6 space-y-2">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => {
                    onNavigate(item.id);
                    setIsOpen(false);
                }}
                className={`w-full text-left px-4 py-3 rounded-sm font-sans font-bold text-sm tracking-widest uppercase flex items-center gap-3 transition-colors
                  ${activePage === item.id 
                    ? 'text-guild-gold bg-guild-bg border-l-4 border-guild-gold' 
                    : 'text-gray-600 hover:text-guild-gold hover:bg-gray-50'
                  }`}
              >
                {item.icon}
                {item.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};